export const pheromoneStatusTranslatePaths = {
  title: 'pheromones.pheromone_status.title',
  lifespan: 'pheromones.pheromone_status.lifespan',
  refilled_at: 'pheromones.pheromone_status.refilled_at',
  next_refilled: 'pheromones.pheromone_status.next_refilled',
  error: 'pheromones.pheromone_status.error',
};
